<script>
  export let idFiche;
  export let titre = 'Quel type de trappes voulez-vous configurer ?';
  let number = parseInt(idFiche) + 1;

  import BtnInfo from '../BtnInfo/BtnInfo.svelte';
</script>

<div class="hero-text">
  <!-- <div class="flex align-top gap-4 mb-16">
    {#if idFiche}
    <div class="flex-none">
      <div
      class="border-4  border-seminYellow h-16 w-16 bg-seminBlue text-seminYellow text-2xl text-center font-extrabold flex items-center justify-center rounded-full"
      >
        {number}
      </div>
    </div>
    {/if}
    <div class="flex-grow">
      <div class="test2" style="z-index:100">{titre}</div>
    </div>
  </div> -->

  {#if idFiche}
    <div class="as-number">{number}</div>
    {#if number==1}
      <BtnInfo /> 
    {/if}
  {/if}
  <div class="as-titre mt-4" style="z-index:100">{titre}</div>
</div>

<style>
  .as-number {
    display: inline-block;
    font-family: 'introblack';
    color: #000;
    font-size: 80px;
    line-height: 60px;
    border-bottom: 9px solid #000;
  }
  .as-titre {
    font-family: 'introblack';
    color: #000;
    font-size: 35px;
  }
  @media only screen and (max-width: 768px) {
    .as-number {
      font-size: 14vw;
      line-height: 10vw;
    }
    .as-titre {
      font-size: 7vw;
      line-height: 8vw;
    }
  }
</style>
